import { Pipe, PipeTransform } from "@angular/core";
import { findIndex } from "lodash";
import { IFilter } from "../../shared/models/filter.model";

@Pipe({
  name: "filterArrayBy",
})
export class FilterArrayPipe implements PipeTransform {
  public transform(items: any[], filters: IFilter[], value: string) {
    if (!items || !filters || !value) {
      return items;
    }

    if (value) {
      value = value.toLowerCase();
    }

    const elementsFiltered = [];

    for (const item of items) {
      const ponderation: any[] = [];
      for (const filterItem of filters) {
        // item['name']==='sebas'
        // [false,true,true,true]
        if (filterItem.multiLanguage) {
          ponderation.push(this.checkMultiLanguage(item, filterItem, value));
        } else {
          ponderation.push(item[filterItem.filter].toString().toLowerCase().includes(value));
        }
      }
      if (findIndex(ponderation, (i) => i === true) !== -1) {
        elementsFiltered.push(item);
      }
    }
    return elementsFiltered;
  }

  public checkMultiLanguage(item, filterItem, value) {
    if (item[filterItem.filter].en.toLowerCase().includes(value) ||
      item[filterItem.filter].es.toLowerCase().includes(value)) {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pipes/filter-array/filter-array.pipe.ts